/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */
import type {
    QueryClient,
    QueryKey,
    QueryObserverOptions,
    UseQueryResult,
} from '@tanstack/react-query'
import { queryOptions, useQuery } from '@tanstack/react-query'

import fetch from 'Common/utils/query/workRequestClient.ts'
import type {
    RequestConfig,
    ResponseConfig,
    ResponseErrorConfig,
} from 'Common/utils/query/workRequestClient.ts'

import type { GetV1MaingroupsQueryResponse } from '../../types/GetV1Maingroups.ts'

export const getV1MaingroupsQueryKey = () => [{ url: '/v1/MainGroups' }] as const

export type GetV1MaingroupsQueryKey = ReturnType<typeof getV1MaingroupsQueryKey>

/**
 * {@link /v1/MainGroups}
 */
export async function getV1Maingroups(
    config: Partial<RequestConfig> & { client?: typeof fetch } = {},
) {
    const { client: request = fetch, ...requestConfig } = config

    const res = await request<GetV1MaingroupsQueryResponse, ResponseErrorConfig<Error>, unknown>({
        method: 'GET',
        url: `/v1/MainGroups`,
        ...requestConfig,
    })
    return res
}

export function getV1MaingroupsQueryOptions(
    config: Partial<RequestConfig> & { client?: typeof fetch } = {},
) {
    const queryKey = getV1MaingroupsQueryKey()
    return queryOptions<
        ResponseConfig<GetV1MaingroupsQueryResponse>,
        ResponseErrorConfig<Error>,
        ResponseConfig<GetV1MaingroupsQueryResponse>,
        typeof queryKey
    >({
        queryKey,
        queryFn: async ({ signal }) => {
            config.signal = signal
            return getV1Maingroups(config)
        },
    })
}

/**
 * {@link /v1/MainGroups}
 */
export function useGetV1Maingroups<
    TData = ResponseConfig<GetV1MaingroupsQueryResponse>,
    TQueryData = ResponseConfig<GetV1MaingroupsQueryResponse>,
    TQueryKey extends QueryKey = GetV1MaingroupsQueryKey,
>(
    options: {
        query?: Partial<
            QueryObserverOptions<
                ResponseConfig<GetV1MaingroupsQueryResponse>,
                ResponseErrorConfig<Error>,
                TData,
                TQueryData,
                TQueryKey
            >
        > & { client?: QueryClient }
        client?: Partial<RequestConfig> & { client?: typeof fetch }
    } = {},
) {
    const { query: queryConfig = {}, client: config = {} } = options ?? {}
    const { client: queryClient, ...queryOptions } = queryConfig
    const queryKey = queryOptions?.queryKey ?? getV1MaingroupsQueryKey()

    const query = useQuery(
        {
            ...getV1MaingroupsQueryOptions(config),
            queryKey,
            ...queryOptions,
        } as unknown as QueryObserverOptions,
        queryClient,
    ) as UseQueryResult<TData, ResponseErrorConfig<Error>> & { queryKey: TQueryKey }

    query.queryKey = queryKey as TQueryKey

    return query
}
